var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{attrs:{"color":"warning","small":""}},[_c('v-icon',{domProps:{"textContent":_vm._s('mdi-close-octagon-outline')}}),_vm._v(_vm._s(_vm.label)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }